import React, { ReactElement } from 'react';

interface Props<T> {
  data: T[];
  itemAttributeToShow?: keyof T;
}

const TableArray = (<T, >({
  data,
  itemAttributeToShow,
}: Props<T>): ReactElement => (
  <>
    {
        data.length === 1
          ? data[0][itemAttributeToShow] : (
            <ul>
              {data
                ?.map((dataItem, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <li key={index}>{dataItem[itemAttributeToShow]}</li>
                ))}
            </ul>
          )
      }
  </>
  ));

export default TableArray;
